module.exports = __webpack_public_path__ + "img/coach-slider3teamimg.4d9bed96.png";